module.exports = __webpack_public_path__ + "static/media/screening_image002.24cff10a.png";